<div class="body" [ngClass]="{ 
    'started': (step.status|async) === StepStatus.Started,
    'succeeded': (step.status|async) === StepStatus.Succeeded,
    'failed': (step.status|async) === StepStatus.Failed
}">

    <div class="index">
        {{index+1}}
    </div>

    <div class="content-wrapper">

        <div class="command-wrapper" [ngClass]="{ 
            'started': (step.status|async) === StepStatus.Started,
            'succeeded': (step.status|async) === StepStatus.Succeeded,
            'failed': (step.status|async) === StepStatus.Failed
        }">

            <div class="title">{{step.title()|async}}</div>

        </div>

        <div class="dynamic-content-wrapper">

            <ng-container #dynamicInner></ng-container>

        </div>

    </div>

    <div class="options-wrapper">

        <button mat-icon-button (click)="toggleDynamicView()"
            [style.visibility]="step.summaryView? 'visible': 'hidden'">
            <mat-icon>{{(dynamicViewVisible|async)? 'expand_less': 'expand_more'}}</mat-icon>
        </button>

    </div>

</div>